var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueTypeaheadBootstrap',{class:[_vm.stateClass],attrs:{"data":_vm.paises,"serializer":(item) => item.nome,"placeholder":_vm.placeholder,"size":_vm.size,"showAllResults":""},on:{"input":_vm.findPais,"hit":function($event){_vm.pais = $event}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }